import { __styles } from '@griffel/react';
import { typographyStyles } from '@fluentui/react-theme';
export const caption1StrongerClassNames = {
  root: 'fui-Caption1Stronger'
};
/**
 * Styles for the root slot
 */
export const useCaption1StrongerStyles = /*#__PURE__*/__styles({
  root: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "fy9rknc",
    Bhrd7zp: "flh3ekv",
    Bg96gwp: "fwrc4pm"
  }
}, {
  d: [".fk6fouc{font-family:var(--fontFamilyBase);}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".flh3ekv{font-weight:var(--fontWeightBold);}", ".fwrc4pm{line-height:var(--lineHeightBase200);}"]
});